import * as React from 'react';

import Draggable from 'react-draggable';
import Paper, { PaperProps } from '@mui/material/Paper';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

import { CustomDialogInterface } from '../../Models/Common/CustomViewsInterfaces';

import CustomHeaderTitleWithSub from './CustomViews/CustomHeaderTitleWithSub';

function DraggablePaperComponent(props: PaperProps) {
    const nodeRef = React.useRef<HTMLDivElement>(null);

    return (
        <Draggable
            nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
            handle="#alert-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'} >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const CustomDialog = (fieldProps: CustomDialogInterface) => {
    return <Dialog className={fieldProps?.dialogClassName ?? ""} {...{
        PaperComponent: DraggablePaperComponent,
        open: fieldProps?.openDialog ?? false,
        disablePortal: fieldProps?.disablePortal ?? false,
        onClose: (e: any) => {
            if(fieldProps?.onCloseDialog) {
                fieldProps.onCloseDialog(e);
            }
        },
        'aria-labelledby': "customized-dialog-title",
        'aria-describedby': "alert-dialog-description",
        TransitionProps: {
            onExited: (e: any) => {
                if(fieldProps?.onCloseDialog) {
                    fieldProps.onCloseDialog(e);
                }
            }
        },
    }} >
        <DialogTitle style={{ cursor: 'move' }} id="alert-dialog-title">
            <CustomHeaderTitleWithSub title={fieldProps?.title ?? ""} subtitle={fieldProps?.subtitle ?? ""} />
        </DialogTitle>

        <DialogContent>
            {fieldProps?.children ?? ""}
        </DialogContent>

        {fieldProps?.actionButtons && <DialogActions>
            {fieldProps.actionButtons}
        </DialogActions>}
    </Dialog >
}

export default CustomDialog;
